<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("foodcategories") }}
      </div>
      <router-link class="btn-blue" to="food-categories"
        >{{ $tc("foodcategories", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fc_category"
                name="foodname"
                id="foodname"
                v-validate="'required'"
                v-b-tooltip.hover.top="'Food Category Name'"
              />
              <label>{{ $tc("foodcategoryname", 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('rawmaterial_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('foodname')">{{
              errors.first("foodname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-1 align-self-center mb-4 px-0">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("isparent") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="is_parent"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div v-if="!is_parent" class="col-lg-6 col-xl-2 align-self-center mb-4">
          <div class="dropdown-curve-container pr-28px">
            <label :class="fc_parent_label.length > 0 ? 'shift-up' : ''">{{
              $tc("parentfoodcategoryname", 2)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="fc_parent_label"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(fc, fcIndex) in ms_food_categories"
                  :key="fcIndex"
                  href="#"
                  :disabled="fc.fc_category == fc_category"
                  @click="
                    fc_parent_id = fc.fc_id;
                    fc_parent_label = fc.fc_category;
                  "
                  >{{ fc.fc_category }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && fc_parent_label == ''"
                >Please Select Parent Food Category.</span
              >
            </p>
          </div>
        </div>

        <div v-if="is_parent" class="col-lg-6 col-xl-2 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="number"
                v-model="fc_order"
                name="foodorder"
                id="foodorder"
                v-b-tooltip.hover.top="'Food Order'"
              />
              <label>{{ $tc("foodorder", 2) }}</label>
            </div>
            <!-- <Tooltip :title="$t('foodorder_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-2 align-self-center mb-4">
          <div
            class="d-flex align-items-center"
            v-b-tooltip.hover.top="
              'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
            "
          >
            <label for="file-selector" class="file-selector w-100">
              <span style="display: inline-block; max-width: 100%; overflow-x: auto; white-space: nowrap;">{{ fc_icon_url }}</span>
              <input
                v-on:change="uploadImage($event)"
                type="file"
                class="d-none"
                name="file-selector"
                id="file-selector"
                
              />
            </label>

            <!-- <Tooltip
              :title="
                `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
              "
            /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && fc_icon_active_url.length == 0"
              >Please Select Food Category Image.</span
            >
          </p>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label for="file-selector2" class="file-selector w-100">
              <span>{{fc_icon_active_url}}</span>
              <input
                v-on:change="uploadActiveImage($event)"
                type="file"
                class="d-none"
                name="file-selector2"
                id="file-selector2"
              />
            </label>

            <Tooltip :title="Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg" />
          </div>
          <p class="error_message">
            <span v-if="submitted && fc_icon_active_url.length == 0">Please Select Food Image.</span>
          </p>
        </div>-->

      

        <div class="col-lg-3 col-xl-1 align-self-center mb-4 px-0">
          <div class="col-lg-12 col-xl-12">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="color"
                  @change="setColor($event, 'font')"
                  v-model="fc_fontColor"
                />
                <label>Font Color</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-1 align-self-center mb-4 px-0">
          <div class="col-lg-12 col-xl-12">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="color"
                  @change="setColor($event, 'background')"
                  v-model="fc_bgColor"
                />
                <label>Background Color</label>
              </div>
            </div>
          </div>
        </div>

          <div class="col-lg-4 col-xl-1 align-self-center mb-4 px-0">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3" >{{ $t("active") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="fc_is_active"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <template v-if="showErpColumns">
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="gl_account"
                name="gl_account"
                id="gl_account"
              />
              <label>Gl Account</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="report_code"
                name="report_code"
                id="report_code"
              />
              <label>Report Code</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>
        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="gl_desc"
                name="gl_desc"
                id="gl_desc"
              />
              <label>Gl Desc</label>
            </div>
          </div>
          <p class="error_message"></p>
        </div>
        </template>

        <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
          <div class="bn-tabs-nav">
            <button
              v-for="(fnbContent, fnbContentIndex) in FnbCategoryContent"
              :key="fnbContentIndex"
              :class="[
                'btn-tab-title ',
                { active: fnbContentIndex == activeClass },
              ]"
              @click.prevent.stop="onChangeTabHandler($event, fnbContentIndex)"
            >
              <strong>
                <span :class="fnbContent.category_name ? '' : 'text-danger'">{{
                  fnbContent.langauge
                }}</span>
              </strong>
            </button>
          </div>
          <div class="bn-tabs-content mt-2">
            <div
              v-for="(fnbContent, fnbContentIndex) in FnbCategoryContent"
              :key="fnbContentIndex"
            >
              <div v-if="fnbContentIndex === activeClass">
                <div class="row">
                  <div class="col-lg-6 col-xl-6 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="fnbContent.category_name"
                          name="fnbcategorynamelang"
                          id="fnbcategorynamelang"
                          v-validate="
                            fnbContent.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                          "
                          v-b-tooltip.hover.top="'foodcategory'"
                        />
                        <label>{{ $t("foodcategoryname") }}</label>
                      </div>
                      <!-- <Tooltip :title="$t('foodcategory')" /> -->
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && errors.has('fnbcategorynamelang')"
                        >{{ errors.first("fnbcategorynamelang") }}</span
                      >
                    </p>
                    <p
                      v-if="fnbContent.langauge.toLowerCase() !== 'english'"
                      class="fs-12"
                    >
                      (Optional)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="food-categories"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import MovieService from "@/services/MovieService";

export default {
  components: { Multiselect },
  data() {
    return {
      btenable: false,
      submitted: false,
      fc_category: "",
      fc_parent_id: 0,
      fc_order: "",
      fc_parent_label: "",
      report_code: "",
      gl_account: "",
      gl_desc: "",
      fc_is_active: true,
      is_parent: true,
      fc_icon_url: "Category icon",
      isIconUpdated: false,
      fc_icon_active_url: "",
      BaseURL: "",
      ms_food_categories: [],
      ContentLanguages: [],
      FnbCategoryContent: [],
      activeClass: 0,
      fc_fontColor: "",
      fc_bgColor: "",
    };
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
  },
  mounted() {
    this.getVendorsList();
    this.getMovieContentLangauge();
  },
  methods: {
    getMovieContentLangauge: function () {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    setColor(event, typeName) {
      if (typeName == "font") {
        this.fc_fontColor = event.target.value;
        console.log(this.fontColor, "fontColor");
      } else {
        this.fc_bgColor = event.target.value;
        console.log(this.bgColor, "bgColor");
      }
    },
    makeLangContainers: function () {
      this.ContentLanguages.map((x) => {
        let Obj = {
          ...x,
          category_name: "",
        };
        this.FnbCategoryContent.push(Obj);
      });
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    getVendorsList: function () {
      let payload = {
        tableName: "ms_food_categories",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records.filter(
              (r) => !r.fc_parent_id
            );
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    uploadImage: function (image1) {
      let self = this;
      let formData = new FormData();
      formData.append("image", image1.target.files[0]);
      formData.append("imagePath", "Category Icon Image");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.isIconUpdated = true;
            self.fc_icon_url = data.path;
            self.fc_icon_active_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError);
    },
    uploadActiveImage: function (image2) {
      let self = this;
      let formData = new FormData();
      formData.append("image", image2.target.files[0]);
      formData.append("imagePath", "Category Icon Image");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.fc_icon_active_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(this._CatchError);
    },
    onResetForm: function () {
      this.fc_category = "";
      this.fc_parent_id = 0;
      this.fc_order = "";
      this.fc_icon_url = "Category Icon";
      this.isIconUpdated = false;
      this.fc_icon_active_url = "";
      this.fc_is_active = true;
      this.fc_fontColor = "";
      this.fc_bgColor = "";
      this.report_code = "";
      this.gl_account = "";
      this.gl_desc = "";
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid && this.isIconUpdated) {
          this.btenable = true;
          let payload = {
            fc_category: this.fc_category,
            fc_parent_id: this.fc_parent_id,
            fc_order: this.fc_order,
            fc_is_active: this.fc_is_active,
            fc_icon_url: this.fc_icon_url,
            fc_icon_active_url: this.fc_icon_active_url,
            fc_fontColor: this.fc_fontColor,
            fc_bgColor: this.fc_bgColor,
            gl_account: this.gl_account,
            gl_desc: this.gl_desc,
            report_code: this.report_code,
            FnbCategoryContent: this.FnbCategoryContent,
          };
          PosFnbService.AddFoodCategory(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$validator.reset();
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "food-categories",
                  });
                  this.$toasted.show(data.message);
                }
                //  else {
                //   this.$router.push({
                //     path: "food-categories"
                //   });
                // }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/addFoodCategories.vue